// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"58720ea2","361":"ca3be582","650":"58720ea2","906":"58720ea2","909":"1fc694d3","932":"58720ea2"}[chunkId] + ".chunk.css";
};